// Drag-to-scroll horizontal.
// Aplica em qualquer elemento com [data-drag-scroll]: arrastar com o
// mouse (desktop) rola o conteúdo horizontalmente. Em touch, o scroll
// nativo + `scroll-snap` (definido via CSS) já cuida do resto.
//
// Vanilla JS de propósito — mesmo arquivo pode ir para assets/ de um
// tema Shopify via {{ 'drag-scroll.js' | asset_url | script_tag }}.
(function () {
  function init() {
    var containers = document.querySelectorAll("[data-drag-scroll]");

    containers.forEach(function (el) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      el.addEventListener("pointerdown", function (e) {
        isDown = true;
        el.classList.add("is-dragging");
        startX = e.pageX;
        scrollLeft = el.scrollLeft;
      });

      el.addEventListener("pointerup", function () {
        isDown = false;
        el.classList.remove("is-dragging");
      });

      el.addEventListener("pointerleave", function () {
        isDown = false;
        el.classList.remove("is-dragging");
      });

      el.addEventListener("pointermove", function (e) {
        if (!isDown) return;
        e.preventDefault();
        var walk = e.pageX - startX;
        el.scrollLeft = scrollLeft - walk;
      });
    });
  }

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();
